import styles from "./ProgressBar.module.scss"
import {
  useEventLoading,
  useEntryLoading,
} from "src/contexts/LoadingContexts"

export function ProgressBar() {
  const { loading: eventLoading } = useEventLoading()
  const { loading: entryLoading } = useEntryLoading()

  if (!eventLoading && !entryLoading) {
    return null
  }

  return (
    <div className={styles.container}>
      <div className={styles.progressBar} />
    </div>
  )
}
